import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { UserGroupComponent } from "../../components/userGroup"

export const UserGroupPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <UserGroupComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}